import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      titleBlinkInterval: null,
      showUnreadMessages: false,
    }
  },
  computed: {
    formattedUnreadCount() {
      return this.$store.getters['chatNew/formattedUnreadCount'] || 0
    },
  },
  watch: {
    formattedUnreadCount: {
      handler() {
        if (process.server) return
        if (!this.formattedUnreadCount) {
          this.showUnreadMessages = false

          if (this.titleBlinkInterval) {
            clearInterval(this.titleBlinkInterval)
            this.titleBlinkInterval = null
          }
          return
        }
        if (this.titleBlinkInterval) {
          clearInterval(this.titleBlinkInterval)
        }
        this.titleBlinkInterval = setInterval(() => {
          this.showUnreadMessages = !this.showUnreadMessages
        }, 1000)
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.titleBlinkInterval) {
      clearInterval(this.titleBlinkInterval)
    }
  },
  methods: {
    getMetaTitle(title?: string) {
      if (process.server) return title
      if (!this.formattedUnreadCount) return title
      if (!this.showUnreadMessages) return title

      return this.formattedUnreadCount === 1
        ? `${this.formattedUnreadCount} unread message`
        : `${this.formattedUnreadCount} unread messages | LaborX`
    },
  },
})
